// Display Number render helper (frontend).
//
// Format: REQ-{CODE}-{NNNN} or CON-{CODE}-{NNNN}.
// {CODE} comes from row.client_display_code (firm) or appConfig.tenant_prefix (in_house).
// {NNNN} is zero-padded to 4 digits, naturally widens past 9999.
//
// See docs/specs/DISPLAY_NUMBER_SPEC.md sections 2 and 6.2.

export type DisplayNumberAppConfig = {
  edition: 'firm' | 'in_house';
  tenant_prefix?: string;
};

export type DisplayNumberRow = {
  display_number?: number | null;
  display_code?: string | null;       // stamped at creation (migration 117) — authoritative
  client_display_code?: string | null; // legacy fallback for unstamped/code-less rows
};

export function formatDisplayNumber(
  row: DisplayNumberRow | null | undefined,
  recordType: 'request' | 'contract',
  appConfig: DisplayNumberAppConfig
): string | null {
  if (!row || row.display_number == null) return null;

  const prefix = recordType === 'request' ? 'REQ' : 'CON';
  const padded = String(row.display_number).padStart(4, '0');

  let code: string;
  if (row.display_code) {
    code = row.display_code.toUpperCase();
  } else if (appConfig.edition === 'in_house') {
    code = (appConfig.tenant_prefix || '').toUpperCase();
  } else {
    code = (row.client_display_code || 'UNK').toUpperCase();
  }

  if (!code) return `${prefix}-${padded}`;
  return `${prefix}-${code}-${padded}`;
}
